<template>
  <div>
    <portal to="app-header">
      <router-link
        to="/particlesjs/demo1"
        class="mr-2"
      >
        go demo1
      </router-link>
      <router-link
        to="/particlesjs/demo2"
        class="mr-2"
      >
        go demo2
      </router-link>
    </portal>
    <router-view />
  </div>
</template>

<script>

export default {
}
</script>

<style>

</style>